var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStarMobile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 15,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFB400",
  fillRule: "evenodd",
  d: "m6.881 0 2.24 4.547 4.659.92-3.261 3.744.627 5.115L6.88 12.09l-4.247 2.235.627-5.115L0 5.468l4.641-.921z",
  clipRule: "evenodd"
})));
export default SvgStarMobile;